import { EnvironmentId } from '@/react/portainer/environments/types';

import { useSecretsForCluster } from './useSecretsForCluster';

/**
 * Secret metadata for a namespace, read through the Portainer API.
 *
 * The Kubernetes proxy returns each secret's data, which Kubernetes only grants to roles
 * allowed to read secret values, so a caller who may see secret names but not their
 * contents is refused. This endpoint never returns data, so it is the read path for
 * anything that needs names, labels or types rather than values.
 */
export function useNamespaceSecrets(
  environmentId: EnvironmentId,
  namespace?: string
) {
  return useSecretsForCluster(environmentId, {
    select: (secrets) =>
      secrets.filter((secret) => secret.Namespace === namespace),
    enabled: !!namespace,
  });
}
